import makerjs, {IMeasureWithCenter, IModel} from 'makerjs';
import Length from "../../../source/js/shared/models/Geometry/Length";
import DrillHole from "./DrillHole";
import OffsetLine from './Lines/OffsetLine';
import { renderLength } from '@/functions/lengths';

export default class RadialDrillHoles {
	x: Length;
	y: Length;
	diameter: Length;
	radialDiameter: Length;
	amount: number;
	enclosingRectangle: IMeasureWithCenter;

	constructor( x: Length, y: Length, diameter: Length, radialDiameter: Length, amount: number, enclosingRectangle: IMeasureWithCenter ) {
		this.x = x;
		this.y = y;
		this.diameter = diameter;
		this.radialDiameter = radialDiameter;
		this.amount = amount;
		this.enclosingRectangle = enclosingRectangle;
	}

	getId(): string {
		return 'radial-drillHoles';
	}

	getPath(): MakerJs.paths.Circle {
		return new DrillHole( this.radialDiameter.divide( 2 ), new Length( 0 ), this.diameter ).getPath();
	}

	cloneToRadial(): IModel {
		return makerjs.layout.cloneToRadial( this.getPath(), this.amount, 360 / this.amount );
	}

	getAsModel(): IModel {
		const radial =this.cloneToRadial();
		radial.type = 'radial-drillHole';

		makerjs.model.zero(radial);
		makerjs.model.move(radial, [ this.x.in_cm(), this.y.in_cm() ]);
		makerjs.model.moveRelative(radial, [ this.enclosingRectangle.low[ 0 ], this.enclosingRectangle.low[ 1 ] ]);

		return radial;
	}

	getOffsetLines(focusedElement = ''): OffsetLine[] {
		if(focusedElement.includes("drillHoleRadialDiameter")) {
			return [
				new OffsetLine(
					[ this.x.subtract(this.radialDiameter.divide(2)).in_mm(), this.y.in_mm() ],
					[ this.x.add(this.radialDiameter.divide(2)).in_mm(), this.y.in_mm() ],
					renderLength(this.radialDiameter.in_cm())
				),
			];
		}

		if(focusedElement.includes("drillHoleRadialOffset")) {
			return [
				new OffsetLine(
					[0, this.y.in_mm()],
					[this.x.in_mm(), this.y.in_mm()],
					renderLength(this.x.in_cm())
				),
				new OffsetLine(
					[this.x.in_mm(), this.y.in_mm()],
					[this.x.in_mm(), 0],
					renderLength(this.y.in_cm())
				),
			];
		}

		return [];
	}
}
